import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { FaqWidget } from '../../../core/models';
import { FaqItemWidgetComponent } from '../faq-item-widget/faq-item-widget.component';
import showdown from 'showdown';
import { SvgComponent } from '../svg/svg.component';
import { AsyncPipe, CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button.component';
import { TranslatePipe } from '@selfcare/cms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { userFeature } from '@src/state';
import { isWidgetVisible } from '@core/helpers';

@Component({
  selector: 'sc-faq-widget',
  imports: [
    FaqItemWidgetComponent,
    SvgComponent,
    CommonModule,
    ButtonComponent,
    TranslatePipe,
    AsyncPipe,
  ],
  templateUrl: './faq-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqWidgetComponent {
  public data = input<FaqWidget>();

  public isAllDisplayed = signal<boolean>(false);

  public isB2B = this.store.selectSignal(userFeature.selectIsB2B);
  public activeProduct = this.store.selectSignal(userFeature.selectActiveProduct);


  public visibleFaqs = computed(() => {
    const activeProduct = this.activeProduct();
    const isB2B = this.isB2B();
    const faqList = this.data()?.faqList ?? [];

    return faqList.filter((faq) => isWidgetVisible(faq, activeProduct, isB2B));
  });

  public displayedFaqs = computed(() => {
    const faqs = this.visibleFaqs().map((faq) => ({
      ...faq,
      answer: this.mdToHtml(faq.answer),
    }));

    return this.isAllDisplayed() ? faqs : faqs.slice(0, this.minDisplayedItems);
  });

  constructor(
    private readonly router: Router,
    private readonly store: Store
  ) { }

  public minDisplayedItems = 5;

  public mdToHtml(md: string) {
    const converter = new showdown.Converter();
    return converter.makeHtml(md);
  }

  public loadMore() {
    this.isAllDisplayed.set(!this.isAllDisplayed());
  }

  get isFaqPage() {
    const currentRoute = this.router.url.split('?')[0].slice(1);
    return currentRoute === 'faq';
  }
}
